import React, { useEffect, useState } from 'react';
import { updateApiHeaders } from '../api/ApiThunks';

/*
 * Causes a rerender after warm-up to ensure warmup data is loaded
 */
export function useWaitForWarmup() {
  const [warmedUp, setWarmedUp] = useState(false);

  useEffect(() => {
    if ('careand_warmup' in window && window.careand_warmup instanceof Promise) {
      window.careand_warmup.finally(() => {
        setWarmedUp(true);
      });
    }
  }, []);

  return warmedUp;
}
